import { render, staticRenderFns } from "./user-notification-board.vue?vue&type=template&id=501ec3c1&scoped=true&"
import script from "./user-notification-board.vue?vue&type=script&lang=ts&"
export * from "./user-notification-board.vue?vue&type=script&lang=ts&"
import style0 from "./user-notification-board.vue?vue&type=style&index=0&id=501ec3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ec3c1",
  null
  
)

export default component.exports